import React, { useContext } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { type ReviewerType, type ReviewerSettingType } from "../types";
import { StaffReviewerStatus } from "../StaffReviewerStatus";
import { SubscriptionReviewerDecision } from "../constants";
import { SubscriptionStaffReviewContextState } from "../context";
import styles from "./styles.scss";

interface StaffReviewerRowProps {
  reviewer: ReviewerType | ReviewerSettingType;
  canStartStaffReview: boolean;
}

export function StaffReviewerRow({
  reviewer,
  canStartStaffReview,
}: StaffReviewerRowProps): React.ReactElement {
  const { data } = useContext(SubscriptionStaffReviewContextState);
  const fullName = `${reviewer.staffUser.firstName} ${reviewer.staffUser.lastName}`;
  const isReviewerType = reviewer.__typename === "SubscriptionReviewerObjectType";
  const isEditable =
    canStartStaffReview && isReviewerType && data?.currentUser?.id === reviewer.staffUser.id;
  const isApproved =
    isReviewerType && reviewer.decision === SubscriptionReviewerDecision.Approve;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="flex-start"
      className={isEditable || isApproved ? "inset-sm-y" : styles.StaffReviewerRow__container}
    >
      <Text>{fullName}</Text>
      {isReviewerType ? (
        <StaffReviewerStatus reviewer={reviewer} isEditable={isEditable} />
      ) : (
        <Text variant="secondary-md" data-cy="not-in-staff-review-banner">
          Subscription pending
        </Text>
      )}
    </Flex>
  );
}
